document.addEventListener("DOMContentLoaded", function () {
    // Seleciona os elementos
    const postGridResults = document.querySelector(".post-grid__results");
    const lineButton = document.querySelector(".line");
    const gridButton = document.querySelector(".grid");

    // Define o estilo padrão ao carregar a página (remove a classe modificadora)
    if (postGridResults) {
        postGridResults.classList.remove("post-grid__results--line");
    }

    // Adiciona o evento de clique para a classe "line"
    if (lineButton) {
        lineButton.addEventListener("click", function () {
            if (postGridResults) {
                postGridResults.classList.add("post-grid__results--line");
            }
        });
    }

    // Adiciona o evento de clique para a classe "grid"
    if (gridButton) {
        gridButton.addEventListener("click", function () {
            if (postGridResults) {
                postGridResults.classList.remove("post-grid__results--line");
            }
        });
    }
});
